<div class="news-view-container d-flex flex-column justify-content-between p-3">
    <h1 class="title">{{ title }}</h1>
    <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <i [class]="authorIconClass + ' user-icon'"></i>
            <span class="author ms-2">{{ author }}</span>
        </div>
        <span class="date">{{ helperService.adjustDateFormatToUTCByAddingZ(date) | date }}</span>
    </div>
</div>